import React from 'react';

export default function Loading({}) {
    return (
        <div className="loading">
            <h2>🌀 Loading...</h2>
            <img src={`/previews/${location.pathname}.png`} alt="loading" />
        </div>
    )
}

